// src/components/layout/SideDrawer.jsx

import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaHome, FaUserTie, FaComments, FaChartBar, FaCog, FaTimes, FaForumbee, FaFolderOpen, FaUsers, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { isUserLoggedIn, hasRole } from "../../pages/userapp/ServiceUserApp";
import { useTranslation } from "react-i18next";
import MenuItem from "./MenuItem";
import "../../styles/SideDrawer.css";

export default function SideDrawer({ open, onClose }) {

    const connected = isUserLoggedIn();

    const isAdmin = hasRole("ADMIN_ROLE");
    const [openAdministration, setOpenAdministration] = useState(false);
    const [openFile, setOpenFile] = useState(false);
    const [openUtilisateur, setOpenUtilisateur] = useState(false);
 const { t } = useTranslation();
    const menus = [
        {
            icon: <FaHome />,
            title: t("menu.home"),
            to: "/",
            public: true
        },

        {
            icon: <FaUserTie />,
            title: t("menu.consultant"),
            to: "/searchconsultant",
            public: true
        },

        {
            icon: <FaComments />,
            title: t("menu.consultation"),
            to: "/consultationrequest",
            public: false
        },

        {
            icon: <FaForumbee />,
            title: t("menu.forum"),
            to: "/forum",
            public: false
        },
    ];

     

    return (
        <aside
            className={
                open
                    ? "side-drawer open"
                    : "side-drawer"
            }
        >
            {/*================================================*/}
            {/* HEADER                                         */}
            {/*================================================*/}

            <div className="drawer-header">
                <h5>
                    {t("menu.mainMenu")}
                </h5>
                <button
                    className="drawer-close"
                    onClick={onClose}
                >
                    <FaTimes />
                </button>

            </div>
            {/*================================================*/}
            {/* MENUS PRINCIPAUX                               */}
            {/*================================================*/}
            <div className="drawer-menu">
                {
                    menus.map((menu) => (
                        <MenuItem
                            key={menu.title}
                            icon={menu.icon}
                            title={menu.title}
                            to={menu.to}
                            disabled={
                                !menu.public &&
                                !connected
                            }
                            onClick={onClose}
                        />
                    ))
                }
                {/*============================================*/}
                {/* ADMINISTRATION                              */}
                {/*============================================*/}
                {/* ADMINISTRATION */}
                {
                    connected && isAdmin && (
                        <>
                            <button
                                className="drawer-submenu-button"
                                onClick={() => {
                                    setOpenAdministration(!openAdministration);
                                }}
                            >
                                <span>
                                    <FaCog className="me-2" />
                                    {t("menu.adminPanel")}
                                </span>
                                {
                                    openAdministration
                                        ? <FaChevronUp />
                                        : <FaChevronDown />
                                }
                            </button>
                        </>
                    )
                }
                {/*============================================*/}
                {/* SOUS MENUS ADMINISTRATION                   */}
                {/*============================================*/}
                {
                    openAdministration && connected && (
                        <div className="drawer-submenu">
                            {/*------------------------------------*/}
                            {/* FICHIER                             */}
                            {/*------------------------------------*/}
                            <button
                                className="drawer-submenu-button"
                                onClick={() => {
                                    setOpenFile(!openFile);
                                }}
                            >
                                <span>
                                    <FaFolderOpen className="me-2" />
                                    {t("menu.file")}
                                </span>
                                {
                                    openFile
                                        ? <FaChevronUp />
                                        : <FaChevronDown />
                                }
                            </button>
                            {
                                openFile && (
                                    <ul className="drawer-submenu-list">
                                        <NavLink
                                            to="/listactivityprof"
                                            className={({ isActive }) =>
                                                isActive
                                                    ? "drawer-submenu-link active"
                                                    : "drawer-submenu-link"
                                            }
                                        >
                                            {t("menu.activityProf")}
                                        </NavLink>

                                        <NavLink
                                            to="/listactivitytype"
                                            className={({ isActive }) =>
                                                isActive
                                                    ? "drawer-submenu-link active"
                                                    : "drawer-submenu-link"
                                            }
                                        >
                                            {t("menu.activityType")}

                                        </NavLink>

                                        <NavLink
                                            to="/liststatut"
                                            className={({ isActive }) =>
                                                isActive
                                                    ? "drawer-submenu-link active"
                                                    : "drawer-submenu-link"
                                            }
                                        >
                                            {t("menu.consultantStatus")}
                                        </NavLink>

                                        <NavLink
                                            to="/listspecialite"
                                            className={({ isActive }) =>
                                                isActive
                                                    ? "drawer-submenu-link active"
                                                    : "drawer-submenu-link"
                                            }
                                        >
                                            {t("menu.speciality")}
                                        </NavLink>

                                        <NavLink
                                            to="/listwilaya"
                                            className={({ isActive }) =>
                                                isActive
                                                    ? "drawer-submenu-link active"
                                                    : "drawer-submenu-link"
                                            }
                                        >
                                            {t("menu.wilaya")}
                                        </NavLink>

                                        <NavLink
                                            to="/listcommune"
                                            className={({ isActive }) =>
                                                isActive
                                                    ? "drawer-submenu-link active"
                                                    : "drawer-submenu-link"
                                            }
                                        >
                                           {t("menu.commune")}
                                        </NavLink>
                                    </ul>
                                )
                            }

                            {/*------------------------------------*/}
                            {/* UTILISATEUR                         */}
                            {/*------------------------------------*/}
                            <button
                                className="drawer-submenu-button"
                                onClick={() => {
                                    setOpenUtilisateur(!openUtilisateur);
                                }}
                            >
                                <span>
                                    <FaUsers className="me-2" />
                                    {t("menu.user")}
                                </span>
                                {
                                    openUtilisateur
                                        ? <FaChevronUp />
                                        : <FaChevronDown />
                                }

                            </button>
                            {
                                openUtilisateur && (
                                    <ul className="drawer-submenu-list">

                                        <li>
                                            <Link
                                                to="/listuserapp"
                                                onClick={onClose}
                                            >
                                                 {t("menu.user")}
                                            </Link>
                                        </li>
         
                                    </ul>
                                )
                            }
                        </div>
                    )
                }
            </div>
            {/*================================================*/}
            {/* FOOTER                                         */}
            {/*================================================*/}
            <div className="drawer-footer">
                <small>
                    FelahLink v1.0
                </small>
            </div>

        </aside>
    );
}